<template>
  <Transition name="toast-transition">
    <div v-if="isVisible" class="toast-box d-flex flex-grow">
      <div class="d-flex justify-content-center align-items-center icon-box" :class="{
        'success': localType === 'success',
        'danger': localType === 'danger',
        'warning': localType === 'warning',
        'info': localType === 'info',
      }">
        <img v-if="localType == 'success'" src="@/assets/images/success-white.png" />
        <img v-if="localType == 'info'" src="@/assets/images/info-white.png" />
        <img v-if="localType == 'danger'" src="@/assets/images/danger-white.png" />
        <img v-if="localType == 'warning'" src="@/assets/images/warning-white.png" />
      </div>
      <div class="d-flex justify-content-center flex-column message-box">
        <div class="message-title">{{ localTitle }}</div>
        <div class="message-message" v-html="localMessage"></div>
      </div>
      <div class="d-flex justify-content-center align-items-center close-box" @click="closeToast">Close</div>
    </div>
  </Transition>
</template>

<script>
export default {
  name: 'Toast',
  props: ['type','title','message', 'duration'],
  data() {
    return {
      isVisible: false,
      localType: this.type,
      localTitle: this.title,
      localMessage: this.message,
      localDuration: this.duration

    };
  },
  methods: {
    showToast(type, title, message, duration) {
      this.localType = type;
      this.localTitle = title;
      this.localMessage = message;
      this.localDuration = duration ?? 3000;
      this.isVisible = true;
      setTimeout(() => {
          this.closeToast();
      }, this.localDuration);
    },
    closeToast() {
      this.isVisible = false;
    },
  },
};
</script>

<style>
.toast-box {
  width: 611px;
  height: 95px;
  position: fixed;
  z-index: 100;
  bottom: 150px;
  right: 10px;
  background: #FFF;
  border-radius: 8px;
  box-shadow: 0px 7px 15px 2px #0000000D;
  transition: all 0.5s ease-in-out;
}

.toast-box .icon-box {
  width: 95px;
  height: 95px;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

.toast-box .icon-box.success {
  background: #508F30;
}

.toast-box .icon-box.warning {
  background: #f7cc53;
}

.toast-box .icon-box.info {
  background: #038edc;
}

.toast-box .icon-box.danger {
  background: #f34e4e;
}

.toast-box .message-box {
  width: 406px;
  padding: 14px 20px;
}

.toast-box .message-box .message-title {
  font-weight: 700;
  font-size: 16px;
}

.toast-box .message-box .message-message {
  font-weight: 500;
  font-size: 14px;
}

.toast-box .close-box {
  font-weight: 500;
  font-size: 14px;
  color: #AFAFAF;
  width: 100px;
  cursor: pointer;
}

.toast-transition-enter-active,
.toast-transition-leave-active {
  transition: all 0.5s cubic-bezier(0.68, -0.55, 0.27, 1.55); /* Increasing the duration for slowly disappearing */
}

.toast-transition-enter-from,
.toast-transition-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

.toast-transition-enter-to,
.toast-transition-leave-from {
  opacity: 1;
  transform: translateX(0);
}
</style>